import { TranslatedText } from "$src/domain/core/TranslatedText";

export function getTranslation(translations: TranslatedText[] | undefined, languageCode: string): string  {
    if( !translations )
        return '';
    
    var translation = translations.find(t => t.languageCode.toUpperCase() == languageCode.toUpperCase())
    if( translation )
        return translation.name;
    return translations.find(t => t.languageCode.toUpperCase() == "EN")?.name ?? '';
}